import React, { useState } from "react"
import SideContainerAnimated from "../SideContainer"
import SideForm from "../SideForm"
import { IFormAddImage } from "./interface"
import pencil from "../../assets/icons/pencil.svg";
import Row from "../Row";
import { Field, Form, Formik } from "formik";
import Button from "../Button";
import { toast } from "react-toastify";
import { Container, ContainerButton, Legend } from "./style";
import Dropzone from "../Dropzone";
import { addImageProduct } from "../../hooks/addImageProduct";
import { errorHandlerApi } from "../../hooks/errorHandlerApi";
import { staticMessagesError } from "../../helpers/staticMessagesError";
import { toastCreate, toastUpdate } from "../../utils/notifications/toast";
import { TIME_INFO, TIME_RESULT } from "../../utils/notifications/time";

const FormAddImage = ({
    isVisible,
    selectedProduct,
    formState,
    setRefresh
}: IFormAddImage
): React.ReactElement => {
    const [newImage, setNewImage] = useState<File>(new File([""], ""));

    return (
        <>
            <SideContainerAnimated isVisible={isVisible}>
                <SideForm
                    title="Adicionar imagem"
                    icon={pencil}
                    sizeIcon={20}
                    visible={() => formState("close")}
                >   
                    <Formik
                        initialValues={{
                            image: "",
                        }}
                        onSubmit={ async () => {
                            const { block, isError } = await addImageProduct(newImage, selectedProduct.id);
                            
                            if(isError) {
                                errorHandlerApi(
                                    block, 
                                    staticMessagesError.UPLOAD_IMAGE,
                                    () => {},
                                    "addImageProduct"
                                )
                            }

                            else {
                                setRefresh(true)
                                toastUpdate(
                                    "addImageProduct",
                                    "success",
                                    TIME_RESULT,
                                    "Imagem adicionada com sucesso!"
                                )
                            }
                        }}
                    >
                    <Container>
                        <Form>
                            <Row>
                                <Container>
                                    <Legend>Adicione uma imagem</Legend>
                                    <Field 
                                        name="image"
                                        onFileUploaded={setNewImage} 
                                        type="image/png" 
                                        as={Dropzone}
                                    />
                                </Container>
                            </Row>
                            <ContainerButton>
                                <Button 
                                    type="submit"
                                    onClick={() => {
                                        toastCreate(
                                            "addImageProduct",
                                            "info",
                                            TIME_INFO,
                                            "Processando..."
                                        )
                                    }}
                                >
                                    Adicionar
                                </Button>
                            </ContainerButton>
                        </Form>
                        </Container>
                </Formik>
                </SideForm>
            </SideContainerAnimated>
        </>
    )
}

export default FormAddImage